import { Injectable } from '@angular/core';

import { FormFactory } from "@magieno/angular-advanced-forms";
import {
  SalaryDividendTaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/salary-dividend/salary-dividend-tax-questionnaire.options';
import {
  ClientQuestionnaireResultBaseFactory,
} from '../../base-client-questionnaire/form/base-result/client-questionnaire-result-base.factory';

@Injectable()
export class SalaryDividendTaxQuestionnaireResultFactory extends ClientQuestionnaireResultBaseFactory {

  constructor(formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = SalaryDividendTaxQuestionnaireOptions;
  }
}
